module.exports = __webpack_public_path__ + "img/icon_3.9a786dbf.png";